import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { PURCHASE_ORDER_ITEM_BREAKDOWN, } from '../types/purchase-order-item-breakdown.js';
/**
 * Descriptor for PurchaseOrderItemBreakdown (size rows under a PO line).
 * Subcollection: org/{orgId}/purchase-order/{purchaseOrderId}/item/{itemId}/breakdown
 *
 * Resolve repository with context: { orgId, purchaseOrderId, itemId }.
 * Mirror of order-item-breakdown (0108).
 */
export const purchaseOrderItemBreakdownDescriptor = {
    name: PURCHASE_ORDER_ITEM_BREAKDOWN,
    label: 'Breakdown do item da ordem de compra',
    domain: 'purchasing',
    collectionPath: 'org/{orgId}/purchase-order/{purchaseOrderId}/item/{itemId}/breakdown',
    pathPatternKeys: {
        orgId: 'string',
        purchaseOrderId: 'string',
        itemId: 'string',
    },
    version: 1,
    description: 'Size distribution of a purchase-order line — full ProductVariant per size (spec 0031 §4.5)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: filho de entidade versionada (spec 0045) — itens em cache voltariam velhos após Recarregar e seriam regravados por cima.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'purchaseOrderItemId',
            label: 'Item da ordem',
            type: 'string',
            required: true,
            description: 'Parent purchase-order line id (also encoded in the path)',
        },
        {
            name: 'variantId',
            label: 'Variante',
            type: 'string',
            required: true,
            description: 'Full ProductVariant (includes size)',
        },
        {
            name: 'quantity',
            label: 'Quantidade',
            type: 'number',
            required: true,
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Variante completa (com tamanho)',
        },
        {
            fieldName: 'purchaseOrderItemId',
            targetEntity: 'PurchaseOrderItem',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Item de ordem de compra pai',
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=purchase-order-item-breakdown.descriptor.js.map